import ZoneDelete from './ZoneDelete'
export {ZoneDelete}
export default ZoneDelete
